const STORAGE_KEY = "mobile_available_roles";

export const readStoredRoles = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const roles = stored ? JSON.parse(stored) : [];
    if (Array.isArray(roles)) return roles;
  } catch {
    // Clear invalid JSON below and keep the app usable.
  }

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage can be unavailable in restricted browser contexts.
  }
  return [];
};
